import React from 'react';
import DroppableList from '../DroppableList';
import DraggableItem from '../DraggableItem';
import { Menu, Edit2, Trash, Info } from 'lucide-react';
import { Card } from '../../ui';

/**
 * Componente para exibir a lista de categorias
 * 
 * @param {Object} props 
 * @param {Array} props.categories - Array de categorias
 * @param {Function} props.onEditCategory - Função chamada ao editar categoria
 * @param {Function} props.onDeleteCategory - Função chamada ao excluir categoria
 * @param {boolean} props.isSaving - Indica se uma operação de salvamento está em andamento
 * @returns {React.ReactElement}
 */
const CategoryList = ({ categories, onEditCategory, onDeleteCategory, isSaving }) => {
  if (!categories?.length) {
    return (
      <div className="text-center py-6 bg-white shadow-sm rounded-xl">
        <p className="text-gray-500 text-sm">Nenhuma categoria cadastrada</p>
      </div>
    );
  }

  return (
    <div className="p-2">
      <DroppableList 
        droppableId="categorias" 
        type="category"
        className={`space-y-1.5 ${isSaving ? 'pointer-events-none opacity-70' : ''}`}
      >
        {categories.map((category, index) => (
          <DraggableItem
            key={category.id || index}
            id={category.id || `category-${index}`}
            index={index}
          >
            <div className="p-1.5 rounded-lg border border-gray-100 bg-white shadow-sm hover:shadow transition-all duration-200 group select-none touch-manipulation">
              <div className="flex items-start justify-between">
                <div className="flex items-start flex-1 space-x-2">
                  <div className="mt-0.5 cursor-move text-gray-300 group-hover:text-gray-500 transition-colors">
                    <Menu size={15} />
                  </div>
                  
                  <div className="flex-1 select-none">
                    <h3 className="font-medium text-gray-900 text-sm select-none">{category.nome || 'Sem nome'}</h3>
                    
                    {category.descricao && (
                      <p className="text-xs text-gray-500 line-clamp-1 mb-1 select-none">{category.descricao}</p>
                    )}
                    
                    <div className="flex flex-wrap gap-1.5 mt-1">
                      <div className="inline-flex items-center px-1.5 py-0.5 rounded bg-gray-50 text-gray-700 text-xs select-none">
                        <Info size={10} className="mr-0.5" />
                        <span>Categoria</span>
                      </div>
                    </div>
                  </div>
                </div>
                
                <div className="flex space-x-1 opacity-0 group-hover:opacity-100 transition-opacity">
                  <button
                    onClick={() => onEditCategory(category)}
                    className="p-1 rounded-full bg-gray-100 hover:bg-gray-200 text-gray-700 transition-colors"
                    aria-label="Editar"
                  >
                    <Edit2 size={13} />
                  </button>
                  <button
                    onClick={() => onDeleteCategory(category)}
                    className="p-1 rounded-full bg-red-50 hover:bg-red-100 text-red-600 transition-colors"
                    aria-label="Excluir"
                  >
                    <Trash size={13} />
                  </button>
                </div>
              </div>
            </div>
          </DraggableItem>
        ))}
      </DroppableList>
    </div>
  );
};

export default CategoryList; 